
<!--
  Attributes:
    positon (Object,相对底部位置)
  methods:
    click-filter
    click-clear
  slot -
  可扩展其他按钮
-->
<template>
  <div :class="[customClass,'action-btn']" :style="{bottom:position.y +'px',right: position.x + 'px'}">
    <el-button :size="size" v-waves type="primary" @click="filter">
      {{$t('public.search')}}
    </el-button>
    <el-button :size="size" v-show="showEmpty" v-waves class="dialog-cancel" type="primary" @click="clear">
      {{$t('public.clear')}}
    </el-button>
    <slot>
    </slot>
    <div v-show="isCollapse" class="search-collapse" @click="clickCollapse">
      <span>{{ !collapse ? $t('public.open'): $t('public.packUp') }}
        <svg-icon :icon-class="!collapse ? 'arrow-down':'arrow-up'" />
        <!-- <svg-icon v-show="collapse" icon-class="arrow-up" /> -->
        <!-- <i :class="!collapse ? 'el-icon-arrow-down': 'el-icon-arrow-up'" /> -->
      </span>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'SearchButton',
  props: {
    position: {
      type: Object,
      default: () => ({
        x: 10,
        y: 12
      })
    },
    customClass: {
      type: String,
      default: ''
    },
    showEmpty: {
      type: Boolean,
      default: true
    },
    isCollapse: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      collapse: false
    }
  },
  methods: {
    filter() {
      this.$emit('click-filter')
    },
    clear() {
      this.$emit('click-clear')
    },
    clickCollapse() {
      this.collapse = !this.collapse
      this.$emit('click-collapse', this.collapse)
    }
  }
}
</script>

<style lang="scss" scoped>
  .action-btn {
    position: absolute;
    display: flex;
    .search-collapse{
      padding: 0 0 0 10px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span{
        font-size:12px
      }
    }
  }
</style>
